import ApolloClient from 'apollo-boost'
import fetch from 'isomorphic-unfetch'

export const newBackendUri = process.env.NEW_BACKEND_ENDPOINT
export const newBackendClient = new ApolloClient({
  uri: newBackendUri,
  fetch: fetch,
})
